function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M60 16.538a3.75 3.75 0 0 0-1.64-3.103L40.86 1.533a3.732 3.732 0 0 0-4.193-.018l-.047.033-14.58 10.725a1.25 1.25 0 0 1-1.48 0L5.968 1.598A3.75 3.75 0 0 0 0 4.625v36.837a3.75 3.75 0 0 0 1.64 3.103l17.5 11.903a3.75 3.75 0 0 0 4.19.017l.048-.035 14.58-10.723a1.25 1.25 0 0 1 1.48 0L54.03 56.404A3.75 3.75 0 0 0 60 53.375V16.538zm-36.25 1.287c0-.393.185-.764.5-1l11-8.227a.625.625 0 0 1 1 .5v31.077c0 .393-.185.764-.5 1l-11 8.23a.625.625 0 0 1-1-.5v-31.08zM5 8.318a.625.625 0 0 1 1-.5l12.25 8.95c.32.233.51.604.513 1v31.204a.623.623 0 0 1-.333.553.63.63 0 0 1-.645-.035L5.56 41.172A1.25 1.25 0 0 1 5 40.14V8.318zM55 49.68a.625.625 0 0 1-1 .5l-12.25-8.955a1.25 1.25 0 0 1-.5-1V9.027c0-.231.127-.444.333-.552a.63.63 0 0 1 .645.035l12.224 8.315c.343.233.548.62.548 1.035v31.82z",
  opacity: 0.69
});

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map.bc364342.svg";
export { ForwardRef as ReactComponent };